/* KAELA — header : mesures de hauteur, etat overlay/opaque, compte a rebours, tiroir mobile */
(function () {
  "use strict";

  function init() {
    var section = document.querySelector(".header-section");
    if (!section) return;

    var wrapper = section.querySelector("[data-header-wrapper]");
    var announcement = section.querySelector(".announcement-bar");

    /* ---------- Hauteurs reelles -> --annc-h / --header-h ----------
       Le hero se cale dessus (height: 100svh - annc, margin-top: -header).
       Le bandeau peut changer de hauteur (police systeme, zoom, mobile),
       donc on mesure au lieu de coder les valeurs en dur. */
    var root = document.documentElement;

    var measure = function () {
      if (announcement) {
        root.style.setProperty("--annc-h", announcement.offsetHeight + "px");
      }
      /* --header-h sert de calage au hero (margin-top negatif). On ne le
         remesure donc JAMAIS pendant que le header est compact ou masque :
         le hero se recalerait sur une hauteur transitoire et sauterait a
         chaque changement de sens du scroll. */
      if (wrapper && !wrapper.classList.contains("is-compact")) {
        root.style.setProperty("--header-h", wrapper.offsetHeight + "px");
      }
    };

    measure();

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(measure);
      if (announcement) ro.observe(announcement);
      if (wrapper) ro.observe(wrapper);
    }

    /* Le ResizeObserver ne suffit pas : au passage mobile -> desktop il peut
       rendre les anciennes hauteurs (mesure prise avant que les media queries
       ne soient appliquees), et le hero garde alors un calage faux — teste,
       il depassait de 20 px sous la fenetre. On remesure donc aussi au resize,
       une frame plus tard pour lire l etat apres recalcul du style. */
    var remeasure = function () {
      measure();
      window.requestAnimationFrame(measure);
    };

    window.addEventListener("resize", remeasure);
    window.addEventListener("orientationchange", remeasure);

    /* Une image de logo lente change la hauteur du header apres coup. */
    window.addEventListener("load", remeasure);

    /* ---------- Overlay -> opaque ----------
       Le header reste transparent tant que l image du hero passe derriere
       lui, et reprend son fond blanc des qu il surplombe le contenu clair.

       Une sentinelle de 1 px collee au bas du hero sert de declencheur, lue
       par IntersectionObserver plutot que par un listener de scroll : pas de
       lecture de scrollY a chaque frame, et le basculement reste juste meme
       si la hauteur du hero change (rotation, barre d URL mobile). */
    if (wrapper && wrapper.classList.contains("header-wrapper--overlay")) {
      var hero = document.querySelector(".hero");

      /* Le seuil est le point ou le bas du hero croise le bas du header.
         Le hero commence juste sous le bandeau (son margin-top negatif annule
         la hauteur du header), donc :
           bas du hero dans le document = bandeau + hauteur du hero
           header colle en haut, sa base est a headerH
         -> opaque des que scrollY depasse bandeau + hero - header. */
      var overlayThreshold = function () {
        if (!hero) return 8;
        var anncH = announcement ? announcement.offsetHeight : 0;
        return Math.max(8, anncH + hero.offsetHeight - wrapper.offsetHeight);
      };

      var limit = overlayThreshold();

      var syncScrollState = function () {
        wrapper.classList.toggle("is-scrolled", window.scrollY >= limit);
      };

      syncScrollState();
      window.addEventListener("scroll", syncScrollState, { passive: true });
      window.addEventListener("resize", function () {
        limit = overlayThreshold();
        syncScrollState();
      });
      window.addEventListener("load", function () {
        limit = overlayThreshold();
        syncScrollState();
      });
    }

    /* ---------- Masquage directionnel ----------
       On descend : le header s efface, la page recupere sa hauteur.
       On remonte : il revient, en version compacte — le lecteur cherche a
       naviguer, pas a admirer le logo.

       Trois garde-fous :
       - une zone morte de 6 px, sinon le trackpad et l inertie iOS font
         clignoter le header sur des micro-mouvements ;
       - rien ne se declenche avant REVEAL_FROM, pour que le haut de page
         garde le header entier (et l overlay du hero intact) ;
       - le header ne se cache jamais tiroir ouvert, ce qui emporterait le
         bouton de fermeture hors de l ecran. */
    if (wrapper) {
      var REVEAL_FROM = 140;
      var ZONE_MORTE = 12;
      var ticking = false;

      /* Le bandeau et le header restent visibles en permanence (voir le sticky
         sur .header-section). Il ne reste donc qu un etat a piloter : la barre
         se tasse des qu on quitte le haut de page, pour rendre de la hauteur
         d ecran sans jamais faire disparaitre le panier ni le menu. */
      /* Deux seuils au lieu d un. Avec un seuil unique, l inertie tactile fait
         osciller scrollY de quelques pixels a l arret : la classe bascule en
         boucle et la transition de 260 ms sur .header ne finit jamais, le
         header pulse. On ne compacte qu au-dessus de 152 px et on ne revient
         qu en dessous de 128 px. */
      var estCompact = wrapper.classList.contains("is-compact");

      var applyScrollState = function () {
        ticking = false;
        var y = window.scrollY;
        if (!estCompact && y > REVEAL_FROM + ZONE_MORTE) estCompact = true;
        else if (estCompact && y < REVEAL_FROM - ZONE_MORTE) estCompact = false;
        else return;
        wrapper.classList.toggle("is-compact", estCompact);
      };

      window.addEventListener("scroll", function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(applyScrollState);
      }, { passive: true });

      applyScrollState();
    }

    /* ---------- Remplissage du bandeau ----------
       L animation translate la piste de -50 %, ce qui suppose deux moities
       identiques ET qu une moitie couvre au moins la largeur de l ecran.
       Avec peu de messages sur un grand ecran ce n est plus le cas : mesure
       a 1158 px de piste pour 1536 px de fenetre, soit un trou de 378 px qui
       traverse le bandeau a chaque tour. On ajoute donc autant de copies que
       necessaire, toujours par paires. */
    var marquee = section.querySelector(".announcement-marquee");

    var fillMarquee = function () {
      if (!marquee) return;
      var tracks = marquee.querySelectorAll(".announcement-track");
      if (tracks.length < 2) return;

      var one = tracks[0];
      var width = one.offsetWidth;
      if (!width) return;

      var needed = Math.ceil(window.innerWidth / width);
      var have = tracks.length / 2;
      if (needed <= have) return;

      for (var i = have; i < needed; i++) {
        for (var half = 0; half < 2; half++) {
          var copy = one.cloneNode(true);
          copy.setAttribute("aria-hidden", "true");
          marquee.appendChild(copy);
        }
      }

      /* L animation parcourt la moitie de la piste : en ajoutant des copies on
         allonge ce trajet, et a duree egale le bandeau defilerait plus vite.
         On etire donc la duree dans la meme proportion — la vitesse en pixels
         par seconde, elle, ne bouge pas. */
      var base = parseFloat(marquee.style.getPropertyValue("--marquee-duration")) || 42;
      if (!marquee.dataset.baseDuration) marquee.dataset.baseDuration = base;
      var ref = parseFloat(marquee.dataset.baseDuration);
      marquee.style.setProperty("--marquee-duration", ref * needed + "s");
    };

    fillMarquee();
    window.addEventListener("resize", fillMarquee);

    /* ---------- Tiroir mobile ---------- */
    var toggle = section.querySelector("[data-drawer-toggle]");
    var drawer = section.querySelector("#menu-drawer");
    var overlay = section.querySelector("[data-drawer-overlay]");

    if (!wrapper || !toggle || !drawer) return;

    var isOpen = false;

    var setDrawerHeight = function () {
      var bottom = wrapper.getBoundingClientRect().bottom;
      var h = Math.max(0, window.innerHeight - bottom);
      section.style.setProperty("--header-drawer-height", h + "px");
    };

    var openDrawer = function () {
      if (isOpen) return;
      isOpen = true;
      setDrawerHeight();
      drawer.classList.add("menu-opening");
      drawer.setAttribute("aria-hidden", "false");
      toggle.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");
      wrapper.classList.add("is-drawer-open");
      if (overlay) overlay.classList.add("is-visible");
      document.body.classList.add("header-drawer-open");
    };

    var closeDrawer = function () {
      if (!isOpen) return;
      isOpen = false;
      drawer.classList.remove("menu-opening");
      drawer.setAttribute("aria-hidden", "true");
      toggle.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      wrapper.classList.remove("is-drawer-open");
      if (overlay) overlay.classList.remove("is-visible");
      document.body.classList.remove("header-drawer-open");
    };

    toggle.addEventListener("click", function () {
      if (isOpen) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    if (overlay) {
      overlay.addEventListener("click", closeDrawer);
    }

    document.addEventListener("keyup", function (e) {
      if (e.key === "Escape") closeDrawer();
    });

    drawer.addEventListener("click", function (e) {
      if (e.target.closest("a")) closeDrawer();
    });

    window.addEventListener("resize", function () {
      if (window.innerWidth >= 990) {
        closeDrawer();
      } else if (isOpen) {
        setDrawerHeight();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
